import { render, staticRenderFns } from "./listMsg.vue?vue&type=template&id=55799462"
import script from "./listMsg.vue?vue&type=script&lang=js"
export * from "./listMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports